import { render, staticRenderFns } from "./TimingRestaurant.vue?vue&type=template&id=f544351e&"
import script from "./TimingRestaurant.vue?vue&type=script&lang=js&"
export * from "./TimingRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./TimingRestaurant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports